import {Link} from 'gatsby';
import React from 'react';

import {createLangShortcut} from '../../../utils/createLangShortcut';
import {
  getCollectionItemBackgroundStyle,
  getCollectionListItemStyle,
} from '../../../utils/getCollectionBackground';
import Carousel from '../../Carousel';

const drawItem = (item, className, parentBackgroundVariant) => {
  const linkedHero = item.correctSlice?.primary;
  const image = item.bild?.fluid?.src || linkedHero?.bild?.fluid?.src;
  const alt = item.bild?.alt;
  const title = item.titel.text || linkedHero?.hero_title.text;
  const text = item.text?.html;
  const localLink = item?.lank.uid;
  const externalLink = item.lank.raw.url;
  const linkLang = item.lank.lang;
  const filter = item.filter;
  const vimeoVideo = item?.vimeo_video?.embed_url;
  let segments = [];
  let videoId = '';
  if (vimeoVideo) {
    segments = vimeoVideo.split('/');
    videoId = segments[segments.length - 1];
  }

  return (
    <div
      className={className}
      key={title}
      style={getCollectionItemBackgroundStyle(parentBackgroundVariant, item.background_variant)}
    >
      <div className={`img-area item-half ${filter ? 'myfilter' : ''}`}>
        {image ? <img src={image} alt={alt} /> : null}
        {vimeoVideo ? (
          <div className="vimeo-video-wrapper collection-vimeo">
            <iframe
              title={title}
              // eslint-disable-next-line max-len
              src={`https://player.vimeo.com/video/${videoId}?speed=0&autoplay=1&controls=0&background=1&quality=720p&loop=1&muted=1}`}
              width="640"
              height="360"
              frameBorder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowFullScreen
            ></iframe>
          </div>
        ) : null}
      </div>
      <div className={`content-area item-half ${text ? 'content-area-with-paragraph' : null}`}>
        <div className="content-area-inner">
          {externalLink || localLink ? (
            <Link
              to={localLink ? '/' + createLangShortcut(linkLang) + '/' + localLink : externalLink}
              target={externalLink ? '_blank' : null}
            >
              <h4 className="linkcolor">{title}</h4>
              <span className="large-list-separator"></span>
            </Link>
          ) : (
            <>
              <h4>{title}</h4>
              <span className="large-list-separator"></span>
            </>
          )}
          <div className="collection-text" dangerouslySetInnerHTML={{__html: text}}></div>
        </div>
      </div>
    </div>
  );
};

export default function CollectionAlternatingLargeList(slice) {
  const listBgStyle = getCollectionListItemStyle(slice.primary.background_variant);
  const carousel = slice.primary.mobil_karusell === true ? true : false;

  return (
    <>
      <section
        className={`tema ${carousel ? 'hidden-by-carousel ' : ' '}`}
        style={listBgStyle}
        key={Math.random()}
      >
        {getAlternatingRows(slice)}
      </section>
      <section
        className={`tema carousel-section ${carousel ? 'carousel-active ' : ' '}`}
        style={listBgStyle}
        key={Math.random()}
      >
        <Carousel>{getCarouselRows(slice)}</Carousel>
      </section>
    </>
  );
}

const getAlternatingRows = (slice) => {
  const gridHtml = [];
  const parentBackgroundVariant = slice.primary.background_variant;

  for (let i = 0; i < slice.items.length; i += 2) {
    if (slice.items[i + 1]) {
      gridHtml.push(
          <div key={i} className="list-large">
            {drawItem(slice.items[i], 'item alt-item', parentBackgroundVariant)}
            {drawItem(slice.items[i + 1], 'item-right alt-item', parentBackgroundVariant)}
          </div>,
      );
    } else {
      gridHtml.push(
          <div key={i} className="list-large">
            {drawItem(slice.items[i], 'item alt-item', parentBackgroundVariant)}
          </div>,
      );
    }
  }
  return gridHtml;
};

const getCarouselRows = (slice) => {
  const gridHtml = [];
  const parentBackgroundVariant = slice.primary.background_variant;

  for (let i = 0; i < slice.items.length; i++) {
    gridHtml.push(
        <div key={i} className="list-large">
          {drawItem(slice.items[i], 'item', parentBackgroundVariant)}
        </div>,
    );
  }

  return gridHtml;
};
